module.exports = __webpack_public_path__ + "static/media/drakkar-header.1df69349.png";